<div
  class="tw-flex tw-flex-col tw-rounded-2xl tw-p-2 tw-shadow-card-elevated tw-bg-dt-surface-card tw-w-full tw-min-w-0"
>
  <div class="tw-flex tw-h-auto tw-flex-col">
    <nav-panel
      [ngClass]="'border-bottom-gray'"
      [title]="'passwordAndHint' | i18n"
      [iconName]="'key-icon'"
      [routerLink]="getRouterLink(SecuritySettingsRoute.ChangePassword)"
    >
      <span>{{ "passwordAndHint" | i18n }}</span>
    </nav-panel>
    <nav-panel
      [ngClass]="'border-bottom-gray'"
      [title]="'loginDevices' | i18n"
      [iconName]="'monitor-icon'"
      [routerLink]="getRouterLink(SecuritySettingsRoute.LoginDevices)"
    >
      <span>{{ "enableBiometricVerification" | i18n }}</span>
    </nav-panel>
    <nav-panel
      [ngClass]="'border-bottom-gray'"
      [title]="'emergencyAccess' | i18n"
      [iconName]="'shield-icon'"
      [routerLink]="getRouterLink(SecuritySettingsRoute.EmergencyAccess)"
      *appRoleScope="'BETA_ACCESS'"
    >
      <span>{{ "trustedEmergencyContacts" | i18n }}</span>
    </nav-panel>
    <nav-panel
      [title]="'twoStepLogin' | i18n"
      [iconName]="'shieldlock-icon'"
      [routerLink]="getRouterLink(SecuritySettingsRoute.TwoStepLogin)"
      *appRoleScope="'BETA_ACCESS'"
    >
      <span>{{ "twoStepLoginDesc" | i18n }}</span>
    </nav-panel>
  </div>
</div>
